import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { api } from "./index.api";
import { Snack } from "../../types/snack.api";
import { FilterQuery, PaginationQuery } from "../../types/query";

const snacksEntity = createEntityAdapter<Snack, string>({
  selectId: (snack: Snack) => snack._id,
});
export type GetSnackType = {
  snacks: EntityState<Snack, string>;
  length: number;
  from: number;
};

const snackApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSnacks: builder.query<
      GetSnackType,
      {
        courseId: string;
        query: FilterQuery<Snack & PaginationQuery>;
      }
    >({
      query: (input) => ({
        url: `/courses/${input.courseId}/snacks`,
        params: input.query,
      }),
      transformResponse(
        baseQueryReturnValue: { snacks: any; length: number; from: number },
        meta,
        arg
      ) {
        return {
          snacks: snacksEntity.addMany(
            snacksEntity.getInitialState(),
            baseQueryReturnValue.snacks as any
          ),
          length: baseQueryReturnValue.length,
          from: baseQueryReturnValue.from,
        };
      },
      providesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "snacks",
            id: api.courseId,
          },
        ];
      },
    }),

    addSnack: builder.mutation<void, { courseId: string; data: FormData }>({
      query: (input) => ({
        url: `/admin/courses/${input.courseId}/snacks`,
        method: "POST",
        body: input.data,
      }),

      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "snacks",
            id: api.courseId,
          },
        ];
      },
    }),

    updateSnack: builder.mutation<
      void,
      { courseId: string; snackId: string; data: FormData }
    >({
      query: (input) => ({
        url: `/admin/snacks/${input.snackId}`,
        method: "PUT",
        body: input.data,
      }),
      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "snacks",
            id: api.courseId,
          },
        ];
      },
    }),

    deleteSnack: builder.mutation<void, { courseId: string; snackId: string }>({
      query: (input) => ({
        url: `/admin/snacks/${input.snackId}`,
        method: "DELETE",
      }),

      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "snacks",
            id: api.courseId,
          },
        ];
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetSnacksQuery,
  useAddSnackMutation,
  useDeleteSnackMutation,
  useUpdateSnackMutation,
} = snackApi;
